
// export default () => ({
    
// })

export default () => ({
    users: null,
    programs: null,
    hfs: null,
    currentUser: null,
    teachers: null,
    usersStaticts: null,
})